<template>
  <div class="auth-page">
    <div class="row">
      <div class="content-section">
        <div class="row">
          <div class="col-8 offset-2 center-content">
            <div>
              <br>
              <br>
              <br>
              <br>
              <img
                src="../../assets/images/chabad-digital-logo.png"
                class="col-6 offset-3 login-logo"
                alt=""
                srcset=""
              />
              <br>
              <br>
              <br>
              <div class="row">
                <div class="col-8 offset-2 login-form-wrap">
                  <h5 class="text-center title">Welcome Back</h5>
                  <h6 class="sub-title text-center">Enter your email and password to continue.</h6>
                  <p v-if="errorMessage" class="text-center text-danger">
                    {{ errorMessage }}
                  </p>
                  <br>
                  <Form class="form" @submit="login">
                    <div class="form-group">
                      <Field
                        id="email"
                        v-model="loginObj.email"
                        :rules="{ required: ['Email'], email: ['Email'] }"
                        type="email"
                        name="email"
                        class="form-control shadow-none"
                        placeholder="Email"
                      />
                      <ErrorMessage name="email" class="form-text text-danger" />
                    </div>
                    <div class="form-group">
                      <Field
                        id="password"
                        v-model="loginObj.password"
                        :rules="{ required: ['Password'] }"
                        type="password"
                        name="password"
                        class="form-control shadow-none"
                        placeholder="Password"
                      />
                      <ErrorMessage name="password" class="form-text text-danger" />
                    </div>
                    <router-link
                      :to="{ name: FORGOT_PASSWORD_ROUTE }"
                      class="forgot-password"
                      >Forgot Password?</router-link
                    >
                    <button
                      type="submit"
                      class="btn btn-dark"
                      :disabled="isLoading ? true : false"
                    >
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Login</span>
                    </button>
                    <div class="divider">
                      <span>OR</span>
                    </div>
                    <button
                      v-on:click="handleGoogleLogin"
                      type="button"
                      class="btn btn-dark btn-oauth"
                      :disabled="isLoading ? true : false"
                    >
                      <img src="../../assets/images/icons/google.png" alt="" />
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span v-if="!isLoading">Continue with Google</span>
                    </button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="text-center copyright text-secondary">
          &copy; Copyright {{ (new Date()).getFullYear() }} Silverkode Inc.
        </span>
      </div>
      <div class="image-section"></div>
    </div>
  </div>
</template>
<script>
import { Field, Form, ErrorMessage, defineRule } from 'vee-validate';
import {
  DASHBOARD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  SIGNUP_PROFILE_ROUTE,
} from '@/router/routes';
import {
  LOGIN,
  LOGIN_OAUTH,
} from '@/store/action_types';
import { useTokenClient } from "vue3-google-signin";
import { TOAST_GLOBAL_CONFIG } from '@/utils/const';

defineRule('email', (value) => {
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegExp.test(value) || 'Email is not valid';
});

defineRule('required', (value, [fieldName = 'Field']) => {
  if (!value || value.length === 0) {
    return `${fieldName} is required`;
  }
  return true;
});

export default {
  title: 'Login',
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    return {
      FORGOT_PASSWORD_ROUTE,
      SIGNUP_PROFILE_ROUTE,
      loginObj: {
        email: null,
        password: null,
      },
    };
  },
  computed: {
    errorMessage() {
      return this.$store.getters.errorMsg;
    },
    isLoading() {
      return this.$store.getters.account.isLoading;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    login() {
      this.$store.dispatch(LOGIN, this.loginObj).then((res) => {
        if (res) {
          this.$router.push({ name: DASHBOARD_ROUTE });
        }
      });
    },
    async handleGoogleLogin() {
      this.isGoogleLoading = true;
      if (!this.isGoogleReady) {
        return;
      }

      try {
        const response = await this.googleLogin();
      } catch (err) {
        console.error('Google login error:', err);
        this.$toast.error('Google login failed. Please try again.', TOAST_GLOBAL_CONFIG);
      } finally {
        this.isGoogleLoading = false;
      }
    },
    loginOAuthGoogle(response) {
      console.log('response', response)
      this.$store.dispatch(LOGIN_OAUTH, { provider: 'google', accessToken: response?.access_token }).then((res) => {
        if(res) {
          this.$router.push({ name: DASHBOARD_ROUTE });
        }
      })
    },
  },
  async created() {
    //  Initialize the Google sign-in client
     const { isReady, login } = useTokenClient({
      onSuccess: (response) => {
        this.loginOAuthGoogle(response);
      },
      onError: (error) => {
        console.error('Google login error', error);
        alert('Google sign-in failed.');
      },
      scope: 'openid email profile',
    });

    // Make login method available on the Vue instance
    this.googleLogin = login;
    this.isGoogleReady = isReady;
  }
};
</script>
<style scoped>
.auth-page {
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.content-section {
  width: 62%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  justify-content: center;
  align-items: center;
}

/* `.content-section` centers its children, so this row is shrink-to-fit: its
   width resolves to min(max-content, available). Percentage column widths are
   ignored while computing max-content, so the row collapsed to the intrinsic
   width of the logo asset (974px) and dragged the whole form in with it.
   Stretch it instead so the form tracks the container, not the image file. */
.content-section > .row {
  align-self: stretch;
}

.image-section {
  width: 38%;
  background-image: url('../../assets/images/login-background.jpg');
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.sub-title {
  font-weight: 400;
  color: #737373;
  font-size: 0.9rem;
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Centers content vertically */
  height: 100%; /* Ensures the div takes full height */
}

.custom-col-width-2 {
  width: var(--sidenav-expanded-width);
}

.custom-col-width-10 {
  width: calc(100% - var(--sidenav-expanded-width));
}

@media (max-width: 1000px) {
  .custom-col-width-2 {
    width: var(--sidenav-expanded-width-sm);
  }

  .custom-col-width-10 {
    width: calc(100% - var(--sidenav-expanded-width-sm));
  }

  .auth-page {
    min-height: 100vh;
    height: 100dvh;
    overflow-y: auto;
    background: #f8f9fc;
  }

  .auth-page > .row {
    min-height: 100%;
    height: 100%;
    margin: 0;
  }

  .image-section {
    display: none;
  }

  .content-section {
    width: 100%;
    min-height: 100%;
    height: auto;
    padding: 48px 20px 24px;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fc;
  }

  .content-section > .row {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 0;
    margin: 0;
  }

  .center-content {
    flex: 0 1 560px;
    width: 100%;
    max-width: 560px;
    height: auto;
    min-height: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    align-items: center;
    transform: translateY(-15%);
  }

  .center-content > div,
  .center-content > div > .row {
    width: 100%;
    margin: 0;
  }

  .center-content br {
    display: none;
  }

  .center-content .col-6,
  .center-content .col-8,
  .center-content .offset-2,
  .center-content .offset-3 {
    flex: none;
    width: 100%;
    max-width: none;
    margin-left: 0;
  }

  /* Higher specificity than `.center-content .col-6` (which forces width:100%),
     defined later, so it wins and the logo renders 30% narrower on small/medium. */
  .center-content .login-logo {
    display: block;
    width: 70%;
    max-width: 70%;
    height: auto;
    margin: 0 auto 30px;
    flex: none;
  }

  .login-form-wrap {
    max-width: 496px;
    margin: 0 auto;
  }

  .title {
    margin: 0 0 8px;
    color: #111827;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
  }

  .sub-title {
    margin: 0;
    font-size: 13px;
    line-height: 1.45;
  }

  .form {
    margin-top: 50px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-control {
    height: 40px;
    border-color: #d5ddeb;
    border-radius: 7px;
    background: #eef5ff;
    color: #0f172a;
    font-size: 12px;
  }

  .forgot-password {
    float: none;
    display: inline-block;
    margin: 0 0 15px;
  }

  .btn-dark {
    min-height: 41px;
    margin-top: 0;
    border-radius: 7px !important;
    font-size: 13px;
    font-weight: 700;
  }

  .btn-oauth,
  .btn-oauth:hover,
  .btn-oauth:focus,
  .btn-oauth:active {
    background-color: var(--color-primary);
    border-color: var(--color-primary) !important;
    color: #ffffff;
  }

  .btn-oauth img {
    width: 18px;
    height: 18px;
    margin-right: 14px;
  }

  .divider {
    margin: 20px 0;
  }

  .copyright {
    position: fixed;
    left: 0;
    bottom: 24px;
    width: 100%;
    padding-bottom: 0;
    color: #64748b !important;
    font-size: 12px;
  }
}

@media (max-width: 575.98px) {
  .content-section {
    padding: 36px 18px 22px;
  }

  .center-content .login-logo {
    width: 70%;
    max-width: 70%;
    margin-bottom: 28px;
  }

  .form {
    margin-top: 44px;
  }
}
</style>